import React, { Component } from 'react';
import { GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
import RadioButtonCodigoGeografico from './RadioButtonCodigoGeografico.jsx';


const LabelDomicilios = ({ data, changeInput, changeRadio, form }) => {
    let domicilio = data.GET_DOMICILIOS;

    let labelDomicilioEmpresa;
    let domicilioEmpresa = null;

    if (domicilio.Direccion.hasOwnProperty('Calle') && domicilio.Direccion.hasOwnProperty('Numero')) {

        domicilioEmpresa = domicilio.Direccion.CodigoDomicilio + " - " +
            domicilio.Direccion.Calle + "  " +
            domicilio.Direccion.Numero.replace(/^0+/, '') + ", " +
            domicilio.Direccion.Localidad + ", " +
            domicilio.Direccion.CodigoPostal + (domicilio.Telefono.Numero ? ( ". (Telefono: " +
            (domicilio.Telefono.Caracteristica != "" ? domicilio.Telefono.Caracteristica + "-" : "") +
            domicilio.Telefono.Numero + ")"): ". (Teléfono no disponible)");

        let nroTelefono = domicilio.Telefono.Caracteristica + domicilio.Telefono.Numero;
        let domicilioEntidad = {
            codigoDomicilio: domicilio.Direccion.CodigoDomicilio,
            calle: domicilio.Direccion.Calle,
            numero: domicilio.Direccion.Numero,
            piso: domicilio.Direccion.Piso,
            localidad: domicilio.Direccion.Localidad,
            codigoPostal: domicilio.Direccion.CodigoPostal,
            departamento: domicilio.Direccion.Departamento,
            telefonoNumero: nroTelefono
        }

        domicilio = domicilioEntidad;

        labelDomicilioEmpresa = <div>
            <label className="label-secondary">{domicilioEmpresa}</label>
        </div>
    }
    else {
        domicilioEmpresa = domicilio.Direccion;
        labelDomicilioEmpresa = <div>
            <label className="alert-danger">{domicilioEmpresa}</label>
        </div>
    }

    return (
        <div>
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div>
                        <label className="label-primary">Domicilio</label>
                    </div>
                    {labelDomicilioEmpresa}
                </div>
            </div>
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div>
                        <RadioButtonCodigoGeografico
                            changeInput={changeInput}
                            changeRadio={changeRadio}
                            data={data}
                            form={form}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LabelDomicilios;